import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthListener } from './components/AuthListener';
import App from './App';
import { LandingPage } from './components/LandingPage';
import { DownloadPage } from './components/DownloadPage';
// Deep link pages
import { DirectArticlePage } from './pages/DirectArticle';
import { SharedArticlePage } from './pages/SharedArticle';
import { SharedCollectionPage } from './pages/SharedCollection';
import { SharedExtractPage } from './pages/SharedExtract';
import { ShareReceiverPage } from './pages/ShareReceiver';
import { SharedExtractPage as AIExtractPage } from './pages/SharedExtractPage';
import './styles/mobile.css';
import './styles/landing.css';
import './styles/highlights.css';
import './styles/search.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthListener />
        <Routes>
          {/* Marketing pages */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/download" element={<DownloadPage />} />

          {/* Deep link routes - public shareable content */}
          <Route path="/s/:token" element={<SharedArticlePage />} />
          <Route path="/c/:token" element={<SharedCollectionPage />} />
          <Route path="/e/:token" element={<SharedExtractPage />} />

          {/* Direct article link - requires auth */}
          <Route path="/a/:id" element={<DirectArticlePage />} />

          {/* AI extract sharing (legacy route) */}
          <Route path="/share/:token" element={<AIExtractPage />} />

          {/* Share receiver - handles incoming shares TO the app */}
          <Route path="/app/share" element={<ShareReceiverPage />} />

          {/* Main app */}
          <Route path="/app/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
